/**
 * 表單送出成功後離開表單。
 *
 * 分步驟的表單（EntityForm 的 steps）每一步都 push 一筆 ?step=N 進瀏覽器歷史，
 * 這樣「上一頁」才等於「上一步」。但建立成功之後，那幾筆就全是死路：
 * 進到新建的工項頁再按返回，會掉回一張已經送出過、內容全空的表單。
 *
 * 這裡先把表單自己 push 的那幾步退掉（回到第一步那一筆），再用 replace 換成目的地，
 * 歷史裡就只剩「進表單之前的那一頁 → 目的地」。
 *
 * 只有在確定退得回去時才退（react-router v6 會在 history.state.idx 記目前是第幾筆）：
 * 直接打開帶 ?step=3 的網址進來的話，前面沒有那幾步，硬退會退出這個網站。
 */
export function leaveFormTo(navigate, url, state) {
  const step = parseInt(new URLSearchParams(window.location.search).get("step") || "1", 10);
  const idx = window.history.state && typeof window.history.state.idx === "number" ? window.history.state.idx : 0;
  const back = Number.isFinite(step) && step > 1 ? Math.min(step - 1, idx) : 0;
  const go = () => navigate(url, { replace: true, state });
  if (!back) {
    go();
    return;
  }
  const onPop = () => {
    window.removeEventListener("popstate", onPop);
    go();
  };
  window.addEventListener("popstate", onPop);
  window.history.go(-back);
}

/**
 * 「返回」：有明確的來處（建立流程帶進來的 backTo）就回那裡；
 * 沒有的話回上一頁；連上一頁都沒有（直接開網址進來）就回 fallback，不要退出網站。
 */
export function goBack(navigate, location, fallback) {
  const backTo = location && location.state && location.state.backTo;
  if (backTo) {
    navigate(backTo);
    return;
  }
  const idx = window.history.state && typeof window.history.state.idx === "number" ? window.history.state.idx : 0;
  if (idx > 0) navigate(-1);
  else navigate(fallback);
}
